import { useEffect, useRef } from "react";
import { Mascot } from "./Mascot";
export function DevFeesModal({ onClose }: { onClose: () => void }) {
  const dialogRef = useRef<HTMLDivElement>(null);
  const closeRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    const previousFocus =
      document.activeElement instanceof HTMLElement
        ? document.activeElement
        : null;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    closeRef.current?.focus();
    const handleKey = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        event.preventDefault();
        onClose();
        return;
      }
      if (event.key !== "Tab" || !dialogRef.current) return;
      const focusable = Array.from(
        dialogRef.current.querySelectorAll<HTMLElement>(
          "button, [href], [tabindex]:not([tabindex='-1'])",
        ),
      );
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };
    document.addEventListener("keydown", handleKey);
    return () => {
      document.removeEventListener("keydown", handleKey);
      document.body.style.overflow = previousOverflow;
      previousFocus?.focus();
    };
  }, [onClose]);
  return (
    <div className="modal-backdrop" role="presentation">
      <div
        ref={dialogRef}
        className="dev-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="dev-fees-title"
        aria-describedby="dev-fees-description"
      >
        <button
          ref={closeRef}
          className="icon-button dev-modal__close"
          type="button"
          aria-label="Close community rewards announcement"
          onClick={onClose}
        >
          ×
        </button>
        <span className="eyebrow">Community rewards</span>
        <div className="dev-modal__art" aria-hidden="true">
          <div className="gold-orbit" />
          <Mascot mood="cheer" size="medium" coin />
        </div>
        <h2 id="dev-fees-title">Loyalty pays off.</h2>
        <p className="dev-modal__subhead">Dev Fees → Loyalty Holders</p>
        <p id="dev-fees-description">
          We're planning to share token-generated Dev Fees with eligible
          long-term holders of our token.
        </p>
        <p className="dev-modal__support">
          Hold your tokens. Stay loyal. Stay tuned.
        </p>
        <button
          className="button button--primary dev-modal__button"
          type="button"
          onClick={onClose}
        >
          Got it!
        </button>
        <small>
          Coming Soon. Distribution terms and eligibility are not yet finalized.
          Rewards are not guaranteed.
        </small>
      </div>
    </div>
  );
}
